var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-leaderboard-feed-entry-badge",class:_vm.getBadgeClass()},[_vm._v("#"+_vm._s(_vm.position))])}
var staticRenderFns = []

export { render, staticRenderFns }